import { render, staticRenderFns } from "./officialAccount.vue?vue&type=template&id=c95d4b5c&scoped=true"
import script from "./officialAccount.vue?vue&type=script&lang=js"
export * from "./officialAccount.vue?vue&type=script&lang=js"
import style0 from "./officialAccount.vue?vue&type=style&index=0&id=c95d4b5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95d4b5c",
  null
  
)

export default component.exports